import { useState, useEffect, useCallback } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, Button, useModal } from '@pancakeswap/uikit'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'
import BuyNowModal from './BuyNowModal'

import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledHardText = styled(Text)`
  color: ${({ theme }) => theme.colors.hardTextColor};
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const StyledHr = styled.hr`
  border-color: ${({ theme }) => theme.colors.hrColor};
  border-size: 1px;
  border-style: solid;
  width: 90%;
  margin-top: 20px;
`

const StyledActionButtons = styled(Flex)`
  @media screen and (max-width: 440px) {
    flex-direction: column;
  }
`

const moneyFormat = (value) => {
  return (+value)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const Tickets = ({ genericprovider }) => {
  const theme = useTheme()
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'

  const [onBuyNow] = useModal(<BuyNowModal />)

  const { account, library } = useWeb3React()
  // const account = "0x780b447c28ec8d7c531af647b9399f8b8100409c";

  const [totalTickets, setTotalTickets] = useState(-1)
  const [ticketsThisRound, setTicketsThisRound] = useState(-1)
  const [winnings, setWinnings] = useState(-1)
  const [winningTickets, setWinningTickets] = useState([])
  const [currentTimestamp, setCurrentTimestamp] = useState(0)
  const [endTimeCurrentCycle, setEndTimeCurrentCycle] = useState(0)

  useEffect(() => {
    const timerinterval = setInterval(() => {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.functions.getEndTimeCurrentCycle().then((endTimeCurrentCycleResp) => {
        setEndTimeCurrentCycle(endTimeCurrentCycleResp[0].toNumber())
        genericprovider.getBlockNumber().then((blockNumber) => {
          genericprovider.getBlock(blockNumber).then((block) => {
            setCurrentTimestamp(block.timestamp)
          })
        })
      })
    }, 10000)
    return () => clearInterval(timerinterval)
  }, [])

  const claimWinnings = useCallback(async () => {
    const contract = new ethers.Contract(contractAddress, abi, library.getSigner())
    const tx = await contract.functions.claimPrizes(winningTickets)
    await tx.wait()
  }, [library, winningTickets])

  useEffect(() => {
    const interval = setInterval(() => {
      if (totalTickets > 0) {
        const contract = new ethers.Contract(contractAddress, abi, genericprovider)
        contract.functions.tokensOfOwner(account).then((tokensOfOwnerResp) => {
          if (totalTickets < tokensOfOwnerResp[0].length) {
            setTotalTickets(tokensOfOwnerResp[0].length)
          }
        })
      }
    }, 10000)
    return () => clearInterval(interval)
  }, [totalTickets])

  useEffect(() => {
    if (account) {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.functions.currentCycle().then((currentCycleResp) => {
        const currentCycle = currentCycleResp[0].toNumber()
        contract.functions.totalSupplyAtCycle(currentCycle - 1).then((totalSupplyAtCycleResp) => {
          const startTokenId = totalSupplyAtCycleResp[0].toNumber() + 1
          contract.functions.tokensOfOwner(account).then((tokensOfOwnerResp) => {
            setTotalTickets(tokensOfOwnerResp[0].length)
            const [activeRoundTickets, inactiveRoundTickets] = tokensOfOwnerResp[0].reduce(
              (acc, tokenId) => {
                if (tokenId >= startTokenId) {
                  acc[0].push(tokenId)
                } else {
                  acc[1].push(tokenId)
                }
                return acc
              },
              [[], []],
            )
            setTicketsThisRound(activeRoundTickets.length)

            try {
              const ticketChunks = []
              while (inactiveRoundTickets.length) {
                ticketChunks.push(inactiveRoundTickets.splice(0, 100)) // chunking into 100 tickets list.
              }
              const promises = []
              for (let i = 0; i < ticketChunks.length; i++) {
                promises.push(contract.functions.getMultipleTokensPrizes(ticketChunks[i]))
              }
              Promise.all(promises)
                .then((results) => {
                  const money = results.reduce((acc, res) => acc.add(res[0]), ethers.BigNumber.from(0))
                  setWinnings(+ethers.utils.formatUnits(money))
                  const tickets = results.reduce((acc, res) => {
                    res[1].reduce((acc2, tokenId) => {
                      if (tokenId.toNumber() > 0) {
                        acc2.push(tokenId)
                      }
                      return acc2
                    }, acc)
                    return acc
                  }, [])
                  setWinningTickets(tickets)
                })
                .catch((err) => {
                  if (err) {
                    console.log(err)
                  }
                })
            } catch (err) {
              if (err) {
                console.log(err)
              }
            }
          })
        })
      })
    }
  }, [account, totalTickets])

  return (
    <StyledCard style={{ flexDirection: 'column' }}>
      <StyledHardText bold style={{ marginTop: 20 }}>
        Tickets
      </StyledHardText>
      <StyledHr />
      <Flex width="90%" mt="22px" mb="20px">
        <StyledSoftText style={{ flexGrow: 1 }}>Your Total Tickets bought</StyledSoftText>
        <Text>{account ? (totalTickets > -1 ? totalTickets : 'Loading...') : 0}</Text>
      </Flex>
      <Flex width="90%" mb="20px">
        <StyledSoftText style={{ flexGrow: 1 }}>Your Tickets this round</StyledSoftText>
        <Text>{account ? (ticketsThisRound > -1 ? ticketsThisRound : 'Loading...') : 0}</Text>
      </Flex>
      <Flex width="90%" mb="20px">
        <StyledSoftText style={{ flexGrow: 1 }}>Winnings</StyledSoftText>
        <Text>{account ? (winnings > -1 ? `${moneyFormat(winnings)} USDT` : 'Loading...') : '0 USDT'}</Text>
      </Flex>
      <StyledActionButtons style={{ gap: 20, marginBottom: 20, marginTop: 16 }}>
        {account ? (
          <Button
            disabled={currentTimestamp === 0 || currentTimestamp > endTimeCurrentCycle}
            onClick={onBuyNow}
            style={{ marginTop: 16, width: '200px', borderRadius: 16 }}
          >
            Buy Tickets!
          </Button>
        ) : (
          <ConnectWalletButton style={{ marginTop: 16, width: '200px', borderRadius: 16 }}>
            Connect Wallet
          </ConnectWalletButton>
        )}
        <Button
          disabled={winnings <= 0}
          onClick={claimWinnings}
          style={{ marginTop: 16, width: '200px', borderRadius: 16 }}
        >
          Claim Winnings
        </Button>
      </StyledActionButtons>
    </StyledCard>
  )
}

export default Tickets
